import React, { memo } from 'react';
import { Testimonial } from './Testimonial';
import { CTAButton } from './CTAButton';
export function MainContent() {
  return <main className="flex-grow" data-id="element-37">
      <div className="container mx-auto px-4 md:px-8 py-6 md:py-12 max-w-4xl" data-id="element-38">
        <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-39">
          <span className="bg-yellow-300" data-id="element-40">Truckers</span> Think Long Hours Cause
          Their <span className="bg-yellow-300" data-id="element-41">Back Pain</span> — But It's
          Actually the <span className="bg-yellow-300" data-id="element-42">Seat</span>
        </h1>
        <h2 className="text-xl md:text-2xl text-gray-700 mb-6" data-id="element-43">
          <span className="underline bg-yellow-100" data-id="element-44">
            The hidden design flaw in 99% of cushions that makes every mile
            worse (and the new solution built for pro drivers)
          </span>
        </h2>
        <div className="text-sm text-gray-600 mb-8 border-b pb-4" data-id="element-45">
          Published by Professional Driver Safety Report
        </div>
        <div className="prose max-w-none text-gray-800" data-id="element-46">
          <p className="font-medium text-lg" data-id="element-47">
            I've been driving trucks for over 20 years. Like most drivers, I
            thought back pain was just part of the job. Long hours, hard seats,
            nothing you can do.
          </p>
          <p data-id="element-48">
            I tried it all — cheap foam cushions, "orthopedic" pads, even a $120
            seat topper off Amazon. Every one of them felt great for a week,
            then collapsed into a pancake. Within hours my lower back felt like
            I was sitting on a 2x4 again.
          </p>
          <p data-id="element-49">
            But here's the truth nobody tells drivers: your pain isn't just from
            sitting. It's from something much worse.
          </p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-50">
            The Hidden Cause
          </h3>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c6rZuegxgh2huEqrLxFwBp/ChatGPT_Image_25_%CE%A3%CE%B5%CF%80_2025%2C_09_13_12_%CF%80.%CE%BC..png" alt="Side-by-side comparison: Car with sophisticated suspension absorbing impact vs. truck with vibrations traveling directly to driver's spine" className="w-full rounded-lg my-6" data-id="element-51" />
          <p data-id="element-52">
            Truck seats don't just press on your back. They vibrate — thousands
            of tiny shocks every mile.
          </p>
          <p data-id="element-53">
            That vibration works like a jackhammer on your spine, hips, and
            tailbone.
          </p>
          <p data-id="element-54">Standard cushions? They aren't designed for it.</p>
          <p data-id="element-55">They collapse under the constant pounding.</p>
          <p data-id="element-56">
            Engineers call it the Compression Creep Effect — and it's why
            cushions bottom out in weeks.
          </p>
          <p data-id="element-57">
            This explains why truckers suffer pain office workers never do. Your
            body isn't just tired — it's being shaken apart.
          </p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-58">
            The Solution Built for Professional Drivers
          </h3>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7GA1AsLRAiSTLKsByedxkU/ChatGPT_Image_25_%CE%A3%CE%B5%CF%80_2025%2C_09_39_08_%CF%80.%CE%BC..png" alt="Cross-section of the Zenseat with Harmonic Dampening Technology showing fabric, memory foam, polymer grid, and support foam layers" className="w-full rounded-lg my-6" data-id="element-59" />
          <p data-id="element-60">
            That's why engineers developed ZenSeat™, the first cushion designed
            specifically for long-haul drivers.
          </p>
          <p data-id="element-61">
            Instead of collapsing like office cushions, ZenSeat uses Harmonic
            Dampening Technology — multi-layered support built to absorb
            vibration mile after mile.
          </p>
          <ul className="list-disc pl-6 my-4 space-y-2" data-id="element-62">
            <li data-id="element-63">Distributes pressure evenly across tailbone and hips</li>
            <li data-id="element-64">Prevents collapse (tested to 500+ hours under vibration)</li>
            <li data-id="element-65">Reduces spinal stress so you finish your shift without pain</li>
            <li data-id="element-66">Durable for pro use — not a cheap Amazon knockoff</li>
          </ul>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-67">
            What Drivers Are Saying
          </h3>
          <Testimonial name="Mike R." title="Owner-Operator" quote="Feels like I added suspension to my seat. I drive 11 hours without that stabbing tailbone pain." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/13JiHy2s8u7gecBVZror2b/download_%2845%29.jpg" data-id="element-68" />
          <Testimonial name="Dan H." title="Long-Haul Driver" quote="Every other cushion I tried flattened in 2 weeks. ZenSeat still feels brand new after 4 months." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/pxaCZrqt8PXDXKLLWGbBLc/download_%2846%29.jpg" data-id="element-69" />
          <Testimonial name="Sarah T." title="Regional Driver" quote="Finally, a cushion that understands truck vibration. My legs don't feel like jello anymore when I get out." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/1ySF8GDuyMSQT1SiN9g7UY/download_%2847%29.jpg" data-id="element-70" />
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-71">
            Imagine Your Next Run Without Pain
          </h3>
          <p data-id="element-72">Imagine finishing your run without:</p>
          <ul className="list-disc pl-6 my-4 space-y-2" data-id="element-73">
            <li data-id="element-74">Constant lower back throbbing</li>
            <li data-id="element-75">Feeling like your legs are "jello" when you climb out</li>
            <li data-id="element-76">Having to stop every 2 hours just to stretch</li>
          </ul>
          <p data-id="element-77">
            Instead, you step out refreshed, ready to enjoy your downtime
            pain-free.
          </p>
          <p data-id="element-78">That's what drivers using ZenSeat are experiencing every day.</p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-79">
            Why ZenSeat Works When Others Fail
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6" data-id="element-80">
            <div className="bg-gray-100 p-4 rounded" data-id="element-81">
              <h4 className="font-bold mb-2" data-id="element-82">
                The Problem with Regular Cushions:
              </h4>
              <p data-id="element-83">
                Most seat cushions are designed for office chairs — static
                sitting with occasional movement. They use basic memory foam
                that compresses under weight and stays compressed.
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded" data-id="element-84">
              <h4 className="font-bold mb-2" data-id="element-85">The ZenSeat Difference:</h4>
              <p data-id="element-86">
                ZenSeat was engineered specifically for truck vibration. The
                Harmonic Dampening Technology actually absorbs and dissipates
                the shock waves that destroy regular cushions.
              </p>
            </div>
          </div>
          <p data-id="element-87">
            Think of it this way: regular foam is like a sponge that gets
            saturated and useless. ZenSeat works like a shock absorber that gets
            stronger under pressure.
          </p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-88">
            Tested by Real Drivers, Not Lab Workers
          </h3>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cjLLfeJXWeB3TXV1sM3nE4/ChatGPT_Image_25_%CE%A3%CE%B5%CF%80_2025%2C_09_33_50_%CF%80.%CE%BC..png" alt="Zenseat being tested in a laboratory setting with vibration testing equipment and a monitor displaying waveforms" className="w-full rounded-lg my-6" data-id="element-89" />
          <p data-id="element-90">
            ZenSeat wasn't developed in some sterile laboratory. It was tested
            by real drivers on real roads:
          </p>
          <ul className="list-disc pl-6 my-4 space-y-2" data-id="element-91">
            <li data-id="element-92">500+ hours of vibration testing in actual truck cabs</li>
            <li data-id="element-93">Field tested on I-40, I-80, and I-10 by working drivers</li>
            <li data-id="element-94">
              Proven durability across Peterbilt, Kenworth, Freightliner, and
              International rigs
            </li>
            <li data-id="element-95">Temperature tested from Arizona heat to Minnesota cold</li>
          </ul>
          <p className="italic" data-id="element-96">
            "We could have made it cheaper," says lead engineer David Chen. "But
            truckers deserve equipment as professional as they are."
          </p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-97">
            The Science Behind the Relief
          </h3>
          <p data-id="element-98">
            When your truck hits a pothole, that impact travels through your
            seat directly into your spine. Regular cushions absorb the first few
            impacts, then compress and transfer the rest straight to your body.
          </p>
          <p data-id="element-99">ZenSeat's multi-layer system works differently:</p>
          <ul className="list-disc pl-6 my-4 space-y-2" data-id="element-100">
            <li data-id="element-101">
              Top layer provides immediate comfort and pressure distribution
            </li>
            <li data-id="element-102">
              Vibration absorption core dissipates shock waves before they reach
              your spine
            </li>
            <li data-id="element-103">
              Base layer maintains structural integrity under constant pressure
            </li>
            <li data-id="element-104">
              Recovery technology ensures the cushion bounces back stronger
              after compression
            </li>
          </ul>
          <p data-id="element-105">The result? Mile 1,000 feels as comfortable as mile 1.</p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-106">
            Professional Driver Guarantee
          </h3>
          <p data-id="element-107">
            Right now, ZenSeat is offering a special 50% off intro discount for
            professional drivers.
          </p>
          <p data-id="element-108">And you're fully covered by a 60-day pain-free guarantee:</p>
          <ul className="list-disc pl-6 my-4 space-y-2" data-id="element-109">
            <li data-id="element-110">Drive with ZenSeat for 60 days</li>
            <li data-id="element-111">
              If your pain isn't reduced, send it back — no questions asked
            </li>
            <li data-id="element-112">We pay return shipping</li>
          </ul>
          <p data-id="element-113">
            Why the guarantee? Because we know ZenSeat works. Over 87% of
            drivers report significant pain reduction within the first two
            weeks.
          </p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-114">
            Stop Sitting on a 2x4. Upgrade Your Seat Today.
          </h3>
          <div className="my-8 text-center" data-id="element-115">
            <CTAButton data-id="element-116" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-117">
            Limited Time Professional Driver Pricing
          </h3>
          <p data-id="element-118">
            This 50% discount exists because professional drivers have been
            ripped off by cheap cushions for too long. You deserve equipment
            that actually works.
          </p>
          <div className="bg-gray-100 p-6 my-8 rounded-lg" data-id="element-119">
            <h4 className="font-bold mb-3" data-id="element-120">What's included:</h4>
            <ul className="list-disc pl-6 space-y-2" data-id="element-121">
              <li data-id="element-122">ZenSeat™ with Harmonic Dampening Technology</li>
              <li data-id="element-123">60-day pain-free guarantee</li>
              <li data-id="element-124">Lifetime warranty against compression failure</li>
              <li data-id="element-125">Priority shipping to truck stops</li>
              <li data-id="element-126">
                24/7 technical support from engineers who understand trucking
              </li>
            </ul>
          </div>
          <p className="font-medium" data-id="element-127">
            Current inventory: 847 units remaining at professional driver
            pricing
          </p>
          <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4" data-id="element-128">
            The Choice Is Yours
          </h3>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cRv2jq1EFP81aZo1XCwnpy/ChatGPT_Image_25_%CE%A3%CE%B5%CF%80_2025%2C_09_44_02_%CF%80.%CE%BC..png" alt="Before and after comparison: Left shows a truck driver grimacing in pain while climbing out of a cab, hunched over. Right shows the same driver looking comfortable and pain-free after using the Zenseat, standing tall with a smile. Small inset of Zenseat cushion in bottom right." className="w-full rounded-lg my-6" data-id="element-129" />
          <p data-id="element-130">
            You can keep trying the same failed solutions — $30 Amazon specials
            that collapse in weeks, leaving you right back where you started.
          </p>
          <p data-id="element-131">
            Or you can join the thousands of drivers who finally understand the
            difference between equipment made for office workers and equipment
            made for professionals.
          </p>
          <p data-id="element-132">
            Other cushions were built for office chairs. ZenSeat was built for
            the open road.
          </p>
          <p data-id="element-133">That's why it lasts, and that's why it works.</p>
          <p data-id="element-134">
            Don't let vibration steal your career or your health. Join thousands
            of drivers already making every mile pain-free with ZenSeat.
          </p>
          <div className="my-8 text-center" data-id="element-135">
            <CTAButton data-id="element-136" />
          </div>
          <p className="text-sm text-gray-600 mt-12" data-id="element-137">
            Limited time offer for verified professional drivers. Subject to
            current inventory. ZenSeat™ is specifically engineered for
            commercial vehicle applications and is not intended to diagnose or
            treat medical conditions.
          </p>
        </div>
      </div>
    </main>;
}